/**
 * Studio Automatic Image Slider
 * Transitions through images automatically with smooth cross-fade
 */

export function initStudioSlider() {
   const sliders = document.querySelectorAll('.js-studio-slider');
   if (!sliders.length) return;

   const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   const SLIDE_INTERVAL = 3500; // 3.5 seconds

   sliders.forEach((slider) => {
      const slides = slider.querySelectorAll('.s-studio__slider-slide');
      if (slides.length <= 1) return;

      let currentIndex = 0;
      let timer = null;
      let isPaused = false;

      function goToSlide(nextIndex) {
         slides[currentIndex].classList.remove('is-active');
         slides[nextIndex].classList.add('is-active');
         currentIndex = nextIndex;
      }

      function nextSlide() {
         const next = (currentIndex + 1) % slides.length;
         goToSlide(next);
      }

      function startTimer() {
         if (prefersReducedMotion || timer) return;
         timer = setInterval(() => {
            if (!isPaused) {
               nextSlide();
            }
         }, SLIDE_INTERVAL);
      }

      function stopTimer() {
         if (timer) {
            clearInterval(timer);
            timer = null;
         }
      }

      // Pause on hover
      slider.addEventListener('mouseenter', () => {
         isPaused = true;
      });

      slider.addEventListener('mouseleave', () => {
         isPaused = false;
      });

      // Pause when browser tab is inactive
      document.addEventListener('visibilitychange', () => {
         if (document.hidden) {
            stopTimer();
         } else {
            startTimer();
         }
      });

      // Initialize
      slides.forEach((slide, idx) => {
         if (idx === 0) {
            slide.classList.add('is-active');
         } else {
            slide.classList.remove('is-active');
         }
      });

      startTimer();
   });
}
